module.exports = class ChangeValuesCtrl
  constructor: ->
    'ngInject'

  $onInit: ->
    @is_array = @changes instanceof Array
